export default __webpack_public_path__ + "static/media/hero-bg.7436d661.png";